import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionarproveidor from "./Seleccionarproveidor";
import Contactes from "./Contactes";
import Comercialsproveidor from "./Comercialsproveidor";
import Sucursalsproveidor from "./Sucursalsproveidor";
import Detallsproveidor from "./Detallsproveidor";
import "../dashboard_v2.css";
import AjudaEntitats from "./AjudaEntitats";
import { BotoAjuda } from "./AjudaModal";

function idProveidor(p) {
  return p ? Number(p.idProveidors) : null;
}

function PestanyesProveidor({ active, onChange }) {
  return (
    <nav className="dv2-subnav" aria-label="Seccions del proveïdor">
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "dades" ? "is-active" : ""}`}
        onClick={() => onChange("dades")}
      >
        Dades
      </button>
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "contactes" ? "is-active" : ""}`}
        onClick={() => onChange("contactes")}
      >
        Contactes
      </button>
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "empleats" ? "is-active" : ""}`}
        onClick={() => onChange("empleats")}
      >
        Empleats
      </button>
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "sucursals" ? "is-active" : ""}`}
        onClick={() => onChange("sucursals")}
      >
        Sucursals
      </button>
    </nav>
  );
}

function Proveidors() {
  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedProveidor, setSelectedProveidor] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [proveidorsList, setProveidorsList] = useState([]);
  const [reloadToken, setReloadToken] = useState(0);

  const { rolUsuari } = useUserContext();
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleProveidorSelect = (proveidor) => {
    if (!proveidor) {
      setSelectedProveidor(null);
      return;
    }
    setSelectedProveidor((prev) => (idProveidor(prev) === idProveidor(proveidor) ? null : proveidor));
  };

  const obrirFitxa = (proveidor, mode) => {
    setSelectedProveidor(proveidor);
    setActiveTab(mode);
  };

  const anarEmpleats = (proveidor) => {
    if (!proveidor) return;
    obrirFitxa(proveidor, "empleats");
  };

  const anarSucursals = (proveidor) => {
    if (!proveidor) return;
    obrirFitxa(proveidor, "sucursals");
  };

  const canviarSeccio = (seccio) => {
    if (seccio === "dades") {
      setActiveTab("consultar");
      return;
    }
    setActiveTab(seccio);
  };

  const esLlista = activeTab === "seleccionar";
  const mostraPestanyes = selectedProveidor && !["nou", "esborrar"].includes(activeTab);
  const seccioActiva =
    activeTab === "contactes"
      ? "contactes"
      : activeTab === "empleats"
      ? "empleats"
      : activeTab === "sucursals"
      ? "sucursals"
      : "dades";
  const subnav = mostraPestanyes ? (
    <PestanyesProveidor active={seccioActiva} onChange={canviarSeccio} />
  ) : null;

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaEntitats pestanya="proveidors" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                🏭
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Proveïdors</h1>
                <p className="dv2-pageHeader-subtitle">
                  Fitxa del proveïdor, contactes, i accés a empleats i sucursals.
                </p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Proveïdors" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedProveidor(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou proveïdor
                </button>
              )}
            </div>
          </div>

          <Seleccionarproveidor
            onProveidorSelect={handleProveidorSelect}
            onConsultar={(p) => obrirFitxa(p, "consultar")}
            onModificar={(p) => obrirFitxa(p, "modificar")}
            onEsborrar={(p) => obrirFitxa(p, "esborrar")}
            onContactes={(p) => obrirFitxa(p, "contactes")}
            onEmpleats={anarEmpleats}
            onSucursals={anarSucursals}
            selectedProveidor={selectedProveidor}
            filterText={filterText}
            setFilterText={setFilterText}
            setProveidors={setProveidorsList}
            reloadToken={reloadToken}
          />
        </>
      ) : activeTab === "contactes" ? (
        <Contactes
          tipusPare="Proveïdor"
          entitat={selectedProveidor}
          subnav={subnav}
          onCancel={() => tornarLlista(false)}
        />
      ) : activeTab === "empleats" ? (
        <Comercialsproveidor
          proveidor={selectedProveidor}
          subnav={subnav}
          onCancel={() => tornarLlista(false)}
        />
      ) : activeTab === "sucursals" ? (
        <Sucursalsproveidor
          proveidor={selectedProveidor}
          subnav={subnav}
          onCancel={() => tornarLlista(false)}
        />
      ) : (
        <Detallsproveidor
          mode={activeTab}
          proveidor={activeTab === "nou" ? null : selectedProveidor}
          proveidors={proveidorsList}
          subnav={subnav}
          onNavigate={setSelectedProveidor}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={(modeNou) => setActiveTab(modeNou)}
          onEmpleats={() => anarEmpleats(selectedProveidor)}
          onSucursals={() => anarSucursals(selectedProveidor)}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedProveidor(updated);
            setProveidorsList((prev) =>
              (prev || []).map((p) => (idProveidor(p) === idProveidor(updated) ? { ...p, ...updated } : p))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Proveidors;
